export const enum FbPixelEvents {
	InitiateCheckout = 'InitiateCheckout',
	Purchase = 'Purchase'
}
